var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoNotice = function SvgIcoNotice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "ico_notice_svg__a",
    width: 16,
    height: 16,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h16v16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#ico_notice_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A36E21",
    d: "M7.474 11.333h1.052V7.298H7.474zM8 6.097q.24 0 .404-.163a.55.55 0 0 0 .163-.404.55.55 0 0 0-.163-.404A.55.55 0 0 0 8 4.964a.55.55 0 0 0-.404.162.55.55 0 0 0-.163.404q0 .241.163.404A.55.55 0 0 0 8 6.097M8 14.667a6.5 6.5 0 0 1-2.6-.525 6.7 6.7 0 0 1-2.117-1.425 6.7 6.7 0 0 1-1.426-2.116A6.5 6.5 0 0 1 1.333 8q0-1.383.525-2.6a6.7 6.7 0 0 1 1.425-2.117q.9-.9 2.116-1.426A6.5 6.5 0 0 1 8 1.333q1.383 0 2.6.525t2.117 1.425 1.426 2.116.525 2.6-.525 2.6a6.7 6.7 0 0 1-1.425 2.117q-.9.9-2.116 1.426a6.5 6.5 0 0 1-2.6.525M8 13.614q2.351 0 3.982-1.632T13.614 8t-1.632-3.982T8 2.386 4.017 4.018Q2.387 5.649 2.386 8q0 2.35 1.631 3.983Q5.65 13.613 8 13.614"
  }))));
};
export default SvgIcoNotice;